import { render } from "./AdminBuilderDetails.vue?vue&type=template&id=554ba96d&scoped=true&ts=true&lang=pug"
import script from "./AdminBuilderDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminBuilderDetails.vue?vue&type=script&lang=ts&setup=true"

import "./AdminBuilderDetails.vue?vue&type=style&index=0&id=554ba96d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554ba96d"]])

export default __exports__